// extracted by mini-css-extract-plugin
module.exports = {"tab-panel-tenders-focus":"focus_tab-panel-tenders-focus__oZPYt","activity":"focus_activity__1fO0c","cpv-icon":"focus_cpv-icon__3EamW"};